import client from "../../../services/session/apiClient";

export const searchCredentials = ({
    provider,
    nameSearch,
    offset,
    includeHasMore,
    limit
}) => {
    return client.get("/v5/credentials/search", { params: {
            provider,
            nameSearch,
            offset,
            includeHasMore,
            limit
        }})
        .then(resp => ({
            results: resp.data.results,
            hasMore: resp.data.hasMore,
        }))
}
